var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVipps(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2061 11.975C12.9811 11.975 14.5561 10.625 16.0561 8.675C16.8811 7.625 17.9311 7.4 18.6811 8C19.4311 8.6 19.5061 9.725 18.6811 10.775C16.5061 13.625 13.7311 15.35 10.2061 15.35C6.38106 15.35 3.00606 13.25 0.681063 9.575C0.00606266 8.6 0.156065 7.55 0.906065 7.025C1.65606 6.5 2.78106 6.725 3.45606 7.775C5.10606 10.25 7.35606 11.975 10.2061 11.975ZM15.3811 2.75C15.3811 4.1 14.3311 5 13.1311 5C11.9311 5 10.8811 4.1 10.8811 2.75C10.8811 1.4 11.9311 0.5 13.1311 0.5C14.3311 0.5 15.3811 1.475 15.3811 2.75Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVipps);
export default __webpack_public_path__ + "static/media/vipps.010456d1cb9621baa0ad5aeb385b24d7.svg";
export { ForwardRef as ReactComponent };